export default "__VITE_ASSET__MQDzJhga__"